import {Badge} from "@mantine/core";
import React from "react";

export function WPage({number}: { number?: string }) {
    if (!number) {
        return null;
    }
    return <Badge size={'md'} variant={'filled'}>{number}</Badge>
}